<template>
	<div class="headCon">
		<div class="content">
			<div class="left">
				<img src="@/static/logo-new.png" class="logo" @click="toHome()" alt="准聘,准聘网,准聘官网,logo"/>
				
				<div class="feature">
					<div v-if="standing=='user'" class="li fonts" @click="go('Home',1)" :class="{'select':routeName=='Home'}">
						首页
					</div>
					<div v-if="standing=='user'" class="li search">
						<div class="fonts" @click="go('Search',2)" :class="{'select':routeName=='Search'}">
							搜索
						</div>
						<div class="dot">
							·
						</div>
						<div class="fonts" @click="go('corporation',3)" :class="{'select':routeName=='corporation'||routeName=='companyDe'}">
							公司
						</div>
					</div>
					<div v-if="standing=='company'" class="li fonts" @click="go('fierce',5)" :class="{'select':routeName=='fierce'}">
						牛人
					</div>
					<div v-if="standing=='company'" class="li fonts" @click="go('deliver',6)" :class="{'select':routeName=='deliver'}">
						投递管理
						<div v-if="deliverPending>0" class="unreadCount"></div>
					</div>
					<div v-if="standing=='company'" class="li fonts" @click="go('poManage',7)" :class="{'select':routeName=='poManage'}">
						职位管理
					</div>
					<div class="li fonts" @click="go('policy',4)" :class="{'select':routeName=='policy'}">
						政策中心
					</div>
					<!-- <div class="li fonts" @click="go('aboutUs',4)" :class="{'select':routeName=='aboutUs'}">
						关于我们
					</div> -->
				</div>
			</div>
			
			<div class="right">
				<!-- <div v-if="$store.state.token==''" class="fonts li" @click="login(2)">
					我要招聘
				</div>
				<div v-if="$store.state.token==''" class="fonts li" @click="login(1)">
					我要找工作
				</div> -->
				<div v-if="$store.state.token" class="fonts li" @click="toggle()">
					{{standing=='user'?'切换成招聘者':'切换为应聘者'}}
				</div>
				<div v-if="!$store.state.token" class="button li" @click="login">
					登录/注册
				</div>
				<div v-else class="info">
					<div class="fonts msgbox" :class="{'select':routeName=='communication'}" @click="go('communication',8)">
						消息
						<div v-if="totalUnreadCount>0" class="unreadCount"></div>
					</div>
					<div v-if="standing=='user'" class="fonts" :class="{'select':routeName=='curriculum'}" @click="go('curriculum',9)">
						简历
					</div>
					<div class="personage" @mouseenter="mouseenter()">
						<div class="text"> {{userinfo.user_name||'未设置'}} </div>
						<div class="avatarbox">
							<el-image v-if="standing=='user'" :src="userinfo.avatar?userinfo.avatar:'@/static/avatar.png'" fit="cover" class="avatar"></el-image>
							<el-image v-else :src="userinfo.en_avatar?userinfo.en_avatar:'@/static/avatar.png'" fit="cover" class="avatar"></el-image>
							<div v-if="joinPending>0&&standing=='company'" class="unreadCount"></div>
							<div v-if="(invitePending>0||waitPending>0) &&standing=='user'" class="unreadCount"></div>
						</div>
						
						<div class="popup" @click.stop="">
							<div class="balanceCon" v-if="standing=='user'||(standing=='company'&&userinfo.en_account_type==2)">
								<div class="label">
									账户余额
								</div>
								<div class="button" @click="openTop()">
									充值
								</div>
								<div class="number">
									{{balance}}
									<span>准币</span>
								</div>
								<!-- <div v-if="frozen_balance>0" class="frozen">
									(含冻结{{frozen_balance}}准币)
								</div> -->
							</div>
							<div class="feature">
								<template v-if="standing=='user'">
									<div v-for="(item,index) of userList" :key="index" class="li">
										<span @click="userGo(item)">{{item.name}}
											<div v-if="(invitePending>0||waitPending>0)&&item.typeName=='inCenter'" class="unreadCount"></div>
										</span>
									</div>
								</template>
								<template v-else>
									<div v-for="(item,index) of companyList" :key="index" class="li">
										<span @click="companyGo(item)">{{item.name}}
											<div v-if="joinPending>0&&item.typeName=='myCenter'" class="unreadCount"></div>
										</span>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<topUp v-if="isTopUpDialogOpen"></topUp>
		</div>
		
		<el-dialog
			title="意见反馈"
			:visible.sync="reportShow"
			:close-on-click-modal="false"
			width="600px">
			<div class="reportBox" v-loading="reportLoading">
				<div class="tips">请尽可能详细描述您所遇到的问题或建议。例如出现问题的时间、频率、当时的操作等信息</div>
				<div class="inputbox">
					<textarea class="textarea" v-model="reason" placeholder="请详细描述您遇到的问题"></textarea>
				</div>
				
				<div class="inputbox">
					<div class="label">图片（最多6张）</div>
					<div class="uploadbox">
						<div class="imgbox" v-for="(item,index) in files" :key="index">
							<el-image class="img" :src="createFileUrl(item)" fit="cover"></el-image>
							<i class="el-icon-error delIcon" @click="delFile(index)"></i>
						</div>
						<div class="imgbox upload" v-if="(6-files.length)>0" @click="chooseImage()">
							<input class="input" id="uploadImg" ref="uploadImg" accept="image/*" type="file" :multiple="true" @change="uploadimg"/>
							<i class="el-icon-picture-outline"></i>
						</div>
					</div>
				</div>
				
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="reportShow = false">取 消</el-button>
					<el-button type="primary" @click="confirmReport()">确 定</el-button>
				</div>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	import topUp from '@/components/topUp.vue'
	import { mapGetters, mapState } from 'vuex';
	export default {
		name: 'hed',
		components:{ topUp },
		computed: {
			...mapGetters(['totalUnreadCount']),
		    ...mapState(['isTopUpDialogOpen','userinfo','deliverPending','joinPending','standing','invitePending','waitPending']),
		},
		data() {
			return {
				routeName:'',
				userList:[
					{
						name:'个人中心',
						typeName:'inCenter'
					},
					{
						name:'申报记录',
						typeName:'declare'
					},
					{
						name:'补贴下发记录',
						typeName:'subsidy'
					},
					{
						name:'准聘用户协议',
						typeName:'agreement',
						query:{type:2}
					},
					{
						name:'个人信息保护政策',
						typeName:'agreement',
						query:{type:3}
					},
					{
						name:'意见反馈',
						typeName:'feedback'
					},
					{
						name:'退出登录',
						typeName:'logout'
					},
				],
				companyList:[
					{
						name:'个人中心',
						typeName:'myCenter',
					},
					
					{
						name:'公司主页',
						typeName:'companyHome'
					},
					{
						name:'政策管理',
						typeName:'policyAdmin'
					},
					// {
					// 	name:'我的客服',
					// 	typeName:''
					// },
					// {
					// 	name:'投诉建议',
					// 	typeName:''
					// },
					// {
					// 	name:'员工列表',
					// 	typeName:''
					// },
					// {
					// 	name:'申请列表',
					// 	typeName:''
					// },
					{
						name:'职位信息发布规则',
						typeName:'agreement',
						query:{type:4}
					},
					{
						name:'意见反馈',
						typeName:'feedback'
					},
					{
						name:'退出登录',
						typeName:'logout'
					},
				],
				balance:0.00,//余额
				frozen_balance:0.00,//冻结余额
				walletsLoading:false,
				timer:null,
				reportShow:false,
				reportLoading:false,
				reason:'',
				files:[],
				websocketTimer:null,
			}
		},
		created() {
			this.routeName = this.$route.name
			if(this.$util.getStorage('token')){
				this.$store.commit('changeToken',this.$util.getStorage('token'))
				this.$axios.get('/api/client/User/info').then(res => {
					this.$util.setStorage('userinfo', res.data)
					this.$store.commit('changeinfo',this.$util.getStorage('userinfo'))
					if(res.data.type=='1'){
						this.$store.commit('changeStanding', 'company')
						this.getCompanyCount()
					}else{
						this.$store.commit('changeStanding', 'user')
						this.getUserCount()
					}
					this.getWallets()
				})
				
			}
			this.initWebSocket()
		},
		watch: {
			$route(e) {
				this.routeName = e.name
			}
		},
		beforeDestroy() {
			clearTimeout(this.websocketTimer)
		},
		methods: {
			getUserCount(){
				this.$axios.get('/api/client/User/getUserPersonalCenterStatistics').then(res=>{
					if(res.code==200){
						const obj = {
							invite:res.data.Interview_count2,
							wait:res.data.Interview_count4
						}
						this.$store.commit('changeInterviewPending',obj)
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			getCompanyCount(){
				this.$axios.get('/api/client/ES/getEnPersonalCenterStatistics').then(res=>{
					if(res.code==200){
						this.$store.commit('changeDeliverPending', res.data.Tobe_invited_count)
						this.$store.commit('changeJoinPending', res.data.totalCompanyJoinApply)
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			initWebSocket() { //初始化weosocket
				console.log('初始化weosocket')
				const wsuri = "wss://zhunpin.work/wss/";
				this.websocket = new WebSocket(wsuri);
				this.websocket.onmessage = this.websocketonmessage;
				this.websocket.onopen = this.websocketonopen;
				this.websocket.onerror = this.websocketonerror;
				this.websocket.onclose = this.websocketclose;
			},
			websocketonopen() { //连接建立之后执行send方法发送数据
				clearTimeout(this.websocketTimer)
			},
			websocketonerror() { //连接建立失败重连
				clearTimeout(this.websocketTimer)
				this.websocketTimer = setTimeout(()=>{
					this.initWebSocket();
				},2000)
			},
			websocketonmessage(e) { //数据接收
				let res = JSON.parse(e.data)
				console.log(res)
				if(res.user_id==this.userinfo.id){
					if(res.type==1) this.getUserCount()
					if(res.type==2) this.getCompanyCount()
				}
			},
			websocketclose() { //关闭
				clearTimeout(this.websocketTimer)
				this.websocketTimer = setTimeout(()=>{
					this.initWebSocket();
				},2000)
			},
			async confirmReport(){
				if(!this.reason) return this.$eltips('请输入您遇到的问题','error')
				let data = {
					content:this.reason
				}
				this.reportLoading = true
				if(this.files.length>0){
					let tokenRes = await this.$axios.get('/api/client/Common/getQiniuToken')
					if(tokenRes.code!=200) return this.reportLoading = false,this.$eltips('上传失败,请稍后再试','warning');
					let files = []
					for(let i=0;i<this.files.length;i++){
						const keys = 'position-report-'+ this.$util.getStorage('userinfo').id +'-'+i+'-'+ new Date().getTime()
						const qiniuUrl = await this.$util.qiniuUpload(this.files[i],keys,tokenRes.data)
						if(!qiniuUrl) return this.reportLoading = false,this.$util.tips('上传图片失败，请稍后重试');
						files.push(qiniuUrl)
					}
					data.images = files.join(',')
				}
				this.$axios.post('/api/client/Common/complaintsSuggestions',data).then(res=>{
					this.reportLoading = false
					if(res.code==200){
						this.$eltips(res.msg,'success')
						this.reportShow = false
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			delFile(index){
				this.files.splice(index,1)
			},
			createFileUrl(file){
				const windowURL = window.URL || window.webkitURL;
				return windowURL.createObjectURL(file)
			},
			chooseImage(){
				if(this.files.length>=6) return;
				this.$refs.uploadImg.click()
			},
			uploadimg(e){
				let imgsFiles = e.target.files
				let max = 6 - this.files.length;
				if(imgsFiles.length>max){
					this.$eltips(`最多上传${max}图片`,'error')
					this.$refs['uploadImg'].value = ''
					return ;
				} 
				for(let i=0;i<imgsFiles.length;i++){
					if(!imgsFiles[i].type.startsWith('image/')){
						this.$eltips('仅支持图片格式','error');
						this.$refs['uploadImg'].value = ''
						return 
					} 
				}
				this.files = [...this.files,...imgsFiles]
				this.$refs['uploadImg'].value = ''
			},
			fnThrottle(method, delay=1000, duration=2000) {
			    var that = this;
			    var timer = this.timer;
			    var begin = new Date().getTime();
			    return function() {
			        var current = new Date().getTime();
			        clearTimeout(timer);
			        if (current - begin >= duration) {
						method();
						begin = current;
			        } else {
						that.timer = setTimeout(function() {
							method();
						}, delay);
			        }
			    };
			},
			mouseenter(){
				this.fnThrottle(this.getWallets)()
			},
			getWallets(){
				if(this.walletsLoading) return;
				if(!this.$util.getStorage('token')) return;
				this.walletsLoading = true
				let url='';
				if(this.standing=='user'){
					url='/api/client/User/wallets'
				}else{
					url='/api/client/ES/wallets'
				}
				this.$axios.get(url).then(res => {
					this.walletsLoading = false
					if (res.code == 200) {
						this.balance=Number(res.data.balance)
						this.frozen_balance=Number(res.data.frozen_balance)
					} else {
						this.$eltips(res.msg,'error')
					}
				})
			},
			toHome(){
				if(this.standing=='user'){
					this.$router.push({ name: 'Home' });
				}else{
					this.$router.push({ name: 'fierce' });
				}
			},
			go(value,status){
				if(status) this.$store.commit('changNav',status);
				 this.$router.push({ name: value });
			},
			login(value){
				if(value==2){
					this.$store.commit('changeLogin',2);
				}else{
					this.$store.commit('changeLogin',1);
				}
				this.$store.commit('changeLoginDialog',true);
			},
			// 打开充值
			openTop(){
				this.$store.commit('changeTopUpDialog',true);
			},
			userGo(item){
				if(item.typeName=='logout'){
					this.$util.restLogin()
					this.$router.push({ name: 'Home' });
				}else if(item.query){
					this.$router.push({ name: item.typeName ,query:item.query});
				}else if(item.typeName=='feedback'){
					this.reason = ''
					this.files = []
					this.reportShow = true
				} else{
					this.$router.push({ name: item.typeName });
				}
			},
			companyGo(item){
				if(item.typeName=='logout'){
					this.$util.restLogin()
					this.$router.push({ name: 'Home' });
				}else if(item.query){
					this.$router.push({ name: item.typeName ,query:item.query});
				}else if(item.typeName=='feedback'){
					this.reason = ''
					this.files = []
					this.reportShow = true
				}  else{
					this.$router.push({ name: item.typeName });
				}
			},
			toggle(){
				if(this.standing=='user'){
					this.judgRequest()
				}else{
					this.toggleRequest(1)
				}
			},
			judgRequest() {
				this.$store.commit('changeLoading',true)
				this.$axios.get('/api/client/ES/getCompanyData').then(res => {
					this.$store.commit('changeLoading',false)
					if (res.code == 500) { //未获取企业信息->新建企业
					    this.$router.push({ name: 'setBusiness',query:{type:1}})
					} else if (res.code == 205) { //申请加入某企业，还在审核中
						this.$alert('请耐心等待', '资料审核中', {confirmButtonText: '确定'});
					} else if (res.code == 206) { //新创建企业，还在审核中
					    this.$alert('请耐心等待', '资料审核中', {confirmButtonText: '确定'});
					} else if (res.code == 200) { //获取到企业信息，进行下一步
					    this.toggleRequest(2)
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 切换身份
			toggleRequest(type){
				this.$axios.post('/api/client/User/SwitchIdentities',{type:type}).then(res => {
					if (res.code == 200) {
						const userinfo = this.$store.state.userinfo
						let userID = type==1?userinfo.user_im_account:userinfo.en_im_account;
						let userSig = type==1?this.$util.getStorage('user_im_sign'):this.$util.getStorage('en_im_sign');
						console.log(userID,userSig)
						this.tim.logout().then(()=>{
							this.tim.login({userID:userID,userSig:userSig}).then((imRes) => {
								if(type==1){
									this.$store.commit('changeStanding', 'user')
									this.$router.push({ name: 'Home'});
									this.getUserCount()
								}else{
									this.$store.commit('changeStanding', 'company')
									this.$router.push({ name: 'fierce'});
									this.getCompanyCount()
								}
								this.getWallets()
							}).catch((err) => {
								console.error('腾讯云即时通讯登录失败------',err)
								this.$eltips('登录失效，请重试','error')
								this.$util.restLogin()
								this.$router.push({ name: 'Home'});
							})
						})
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.headCon {
		width: 100%;
		height: 56px;
		background-color: #212329;
		display: flex;
		justify-content: center;
		.content {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1200px;
			position: relative;
			.fonts{
				color: #FFFFFF;
				&:hover{
					color: #51A190;
				}
				cursor: pointer;
			}
			.left {
				display: flex;
				align-items: center;
				.title {
					color: #51A190;
					font-size: 22px;
					margin-right: 15px;
					font-weight: 600;
				}

				.logo {
					width: 160px;
					height: auto;
					margin-right: 26px;
					display: block;
					cursor: pointer;
				}
				
				.feature{
					display: flex;
					align-items: center;
					.select{
						color: #51A190;
					}
					.li{
						margin-right: 24px;
						font-size: 16px;
						position: relative;
						.unreadCount {
							width: 7px;
							height: 7px;
							background-color: #FF4444;
							border-radius: 50%;
							position: absolute;
							right: -4px;
							top: 0px;
						}
					}
					
					.dot{
						font-size: 16px;
						color: #FFFFFF;
						margin: 0 8px;
					}
					.search{
						display: flex;
						align-items: center;
					}
				}
			}
		
		    .right{
				display: flex;
				align-items: center;
				.li{
					margin-right: 28px;
					font-size: 16px;
					&:last-child{
						margin-right: 0;
					}
				}
				.button{
					width: 104px;
					height: 32px;
					background-color: #51A190;
					border-radius: 8px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
				.msgbox{
					position: relative;
				}
				.unreadCount {
					width: 7px;
					height: 7px;
					background-color: #FF4444;
					border-radius: 50%;
					position: absolute;
					right: -4px;
					top: 0px;
				}
				.info{
					display: flex;
					align-items: center;
					padding-left: 24px;
					position: relative;
					&::after{
						content: '';
						width: 2px;
						height: 24px;
						background: rgba(255, 255, 255, 0.1);
						position: absolute;
						left: 0;
						top: 50%;
						margin-top: -12px;
					}
					.fonts{
						margin-right: 24px;
					}
					.personage{
						display: flex;
						align-items: center;
						color: #FFFFFF;
						cursor: pointer;
						height: 56px;
						.avatarbox{
							margin-left: 10px;
							width: 32px;
							position: relative;
							.avatar{
								width: 32px;
								height: 32px;
								border-radius: 50%;
							}
							.unreadCount {
								width: 8px;
								height: 8px;
								right: -2px;
								top: 0px;
							}
						}
						&:hover .popup{
							display: block;
						}
					}
				}
			}
		
		    .popup{
				display: none;
				padding: 12px;
				box-sizing: border-box;
				position: absolute;
				right: 0;
				top: 56px;
				background-color: #Fff;
				z-index: 998;
				border-radius: 12px;
				border: 2px solid #51A190;
				cursor: default;
				.balanceCon{
					padding: 18px 20px;
					background-color: #383A4A;
					border-radius: 8px;
					position: relative;
					width: 200px;
					box-sizing: border-box;
					margin-bottom: 29px;
					.label{
						color: #DDB990;
						font-size: 12px;
						margin-bottom: 4px;
					}
					.button{
						width: 60px;
						line-height: 28px;
						background-color: #FFE4CA;
						color: #B13800;
						border-radius: 14px;
						font-size: 13px;
						text-align: center;
						position: absolute;
						right: 20px;
						top: 12px;
						cursor: pointer;
					}
					.number{
						display: flex;
						align-items: center;
						font-size: 18px;
						color: #ffffff;
						span{
							font-size: 14px;
						}
					}
					.frozen{
						font-size: 13px;
						color: #ffffff;
						margin-top: 2px;
					}
				}
			    .feature{
					padding-left: 20px;
					.li{
						color: #151515;
						font-size: 16px;
						margin-bottom: 29px;
						position: relative;
						span{
							cursor: pointer;
							position: relative;
							display: inline-block;
							&:hover{
								color: #51A190;
							}
							.unreadCount {
								right: -4px;
								top: 0px;
							}
						}
						&:last-child{
							margin-bottom: 28px;
						}
					}
				}
			}
		}

	}

	.reportBox{
		.tips{
			font-size: 14px;
			margin-bottom: 12px;
		}
		.inputbox{
			margin-bottom: 18px;
			.label{
				font-size: 15px;
				font-weight: bold;
				color: #151515;
				margin-bottom: 14px;
			}
			.textarea{
				all: unset;
				box-sizing: border-box;
				width: 100%;
				height: 140px;
				border-radius: 8px;
				font-size: 14px;
				background: #F8F8F8;
				padding: 14px;
				border: 1px solid #F8F8F8;
				color: #151515;
				&:focus{
					border-color: #51A190;
				}
			}
			.uploadbox{
				display: flex;
				flex-wrap: wrap;
				.imgbox{
					width: 88px;
					height: 88px;
					margin-right: 18px;
					margin-bottom: 18px;
					position: relative;
					.img{
						width: 100%;
						height: 100%;
					}
					.delIcon{
						position: absolute;
						right: -7px;
						top: -7px;
					}
				}
				.upload{
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					border: 1px dashed #ccc;
					position: relative;
					overflow: hidden;
					font-size: 28px;
					&:hover{
						border-color: #51A190;
					}
					.input{
						width: 0;
						height: 0;
						opacity: 0;
					}
				}
			}
		}
	}
</style>